/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_UsageInputs */

const en_admin_usage = /** @type {(inputs: Admin_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usage`)
};

const nl_admin_usage = /** @type {(inputs: Admin_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gebruik`)
};

/**
* | output |
* | --- |
* | "Usage" |
*
* @param {Admin_UsageInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const admin_usage = /** @type {((inputs?: Admin_UsageInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_UsageInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_admin_usage(inputs)
	return en_admin_usage(inputs)
});